import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { AuthService } from '@auth0/auth0-angular';
import { Router, ActivatedRoute } from '@angular/router';
import { TealiumLoaderService } from 'src/app/shared/services/tealium-loader.service';
import { TealiumTargetService } from 'src/app/shared/services/tealium-target.service';

@Component({
  selector: 'app-next-gen-login',
  templateUrl: './next-gen-login.component.html',
  styleUrls: ['./next-gen-login.component.scss']
})
export class NextGenLoginComponent implements OnInit {

  isBouncing: boolean = false;
  showDeletedError: boolean = false;
  isAuthProcessing: boolean = true;

  currentMaintenanceMessage: string | null = null;

   constructor(
      private auth: AuthService,
      @Inject(DOCUMENT) public document: Document,
      private router: Router,
      private route: ActivatedRoute,
      private tealiumTarget: TealiumTargetService
    ) { }


ngOnInit() {

  this.tealiumTarget.initTealium();

  this.checkMaintenanceWindow();

    this.auth.isLoading$.subscribe(isLoading => {
      this.isAuthProcessing = isLoading;
    });

    // 🛑 NEW: CHECK THE URL FOR THE ERROR FLAG FIRST
    this.route.queryParams.subscribe(params => {
      if (params['error'] === 'account_deleted') {
        this.showDeletedError = true;
      }
    });

    // 1. LEGACY SESSION CHECK: If active ONL or PPI session exists, route to legacy Home!
    const hasOnlSession = sessionStorage.getItem('ONLWalletSession');
    const hasPpiSession = sessionStorage.getItem('PPIWalletSession');
    const walletId = sessionStorage.getItem('WalletID');

    if ((hasOnlSession || hasPpiSession) && walletId) {
      this.router.navigate(['/home']);
      return; // Stop execution here so NextGen doesn't load
    }


    // 2. BOUNCE SCENARIO A: User declined T&C and needs to go to UPS.com
    if (localStorage.getItem('redirectToUps') === 'true') {
      this.isBouncing = true; // Hide the Welcome UI
      localStorage.removeItem('redirectToUps'); // Clean up the flag
      window.location.href = 'https://www.ups.com/us/en/home'; // Redirect externally
      return; // Stop execution here
    }

    // 3. BOUNCE SCENARIO B: User logged out and wants to log right back in
    if (localStorage.getItem('triggerAutoLogin') === 'true') {
      this.isBouncing = true; // Hide the Welcome UI
      localStorage.removeItem('triggerAutoLogin'); // Clean up the flag
      this.onLogin(); // Redirect to Auth0
      return; // Stop execution here
    }

    // 4. STANDARD SCENARIO: Normal page load
    // If Auth0 says we are already authenticated AND we don't have an error, go straight to Home.
    this.auth.isAuthenticated$.subscribe(isAuthenticated => {
      // ✅ SAFETY CHECK: Only auto-route to Home if there is NO deleted error
      if (isAuthenticated && !this.showDeletedError) {
        this.router.navigate(['/next-gen-home']);
      }
    });
  }

checkMaintenanceWindow() {
    const now = new Date(); 
    
   // 🟢 UPDATED: Test window starts exactly at 9:00 PM tonight (Thursday, May 14)
    const testStart = new Date('2026-05-14T21:00:00-04:00'); // Tonight 9:00 PM EDT
    const testEnd   = new Date('2026-05-14T23:30:00-04:00'); // Tonight 11:30 PM EDT
    
    const prodStart = new Date('2026-05-15T22:00:00-04:00'); // Friday 10:00 PM EDT
    const prodEnd   = new Date('2026-05-16T14:00:00-04:00'); // Saturday 2:00 PM EDT

    if (now >= testStart && now <= testEnd) {
      this.currentMaintenanceMessage = "The site is undergoing scheduled maintenance and will be unavailable from 9:00 PM ET through 11:30 PM ET on May 14, 2026.";
    } else if (now >= prodStart && now <= prodEnd) {
      this.currentMaintenanceMessage = "The site is undergoing scheduled maintenance and will be unavailable from 10:00 PM ET on May 15 through 2:00 PM ET on May 16.";
    } else {
      this.currentMaintenanceMessage = null; 
    }
}

  onLogin() {
    this.auth.loginWithRedirect({
      appState: { target: '/next-gen-home' }
    });
  }

  onLogout() {
    this.auth.logout({
      logoutParams: {
        returnTo: this.document.location.origin
      }
    });
  }

  // Closes the error toast when the user clicks 'X'
  closeError() {
    this.showDeletedError = false;
  }
}